import React, { Fragment } from 'react'
import { Typography, Button, Box } from '@mui/material'
import { utcToLocal } from '../../../../utils/dateHelper'
import { usePutAway } from '../../Context/usePutAway'
import { putAwayActions } from '../../actions/putAwayActions'
import { useStyles } from './styles'
import StepBackPutAway from '../StepBackPutAway/StepBackPutAway'

interface DescriptionPutAwayProps {}

export const DescriptionPutAway: React.FC<DescriptionPutAwayProps> = () => {
  const { state, dispatch } = usePutAway()
  const {
    mapperDetailsOptions,
    setStep,
    getWorkOrderSkuHistory,
    putBloqUserLpn
  } = putAwayActions()
  const { item, isSelected } = state
  const classes = useStyles()

  const dateCreated =
    isSelected === 'WorkOrderId'
      ? item?.workOrderCreatedAt
      : item?.asnCreatedDate

  const utcDate = utcToLocal(dateCreated!, 'dd-MM-yyyy')

  if (item) {
    return (
      <div className={classes.flexContainer}>
        <StepBackPutAway />
        <Box
          component='div'
          display='flex'
          flexDirection='column'
          flexWrap='nowrap'
          alignItems='left'
          padding='10px'
        >
          <Typography
            variant='h5'
            style={{
              fontSize: '20px',
              fontWeight: 'bold',
              marginTop: '30px'
            }}
          >
            {`Detalle de ${mapperDetailsOptions(item)}`}
          </Typography>
          <Typography variant='h6' className={classes.details}>
            <b>Fecha de creación: </b>
            {utcDate}
          </Typography>
          <Typography variant='h6' className={classes.details}>
            <b>OT: </b> {item.workOrderId}
          </Typography>
          <Typography variant='h6' className={classes.details}>
            <b>Marca: </b> {item.brandName}
          </Typography>
          <Typography variant='h6' className={classes.details}>
            <b>Proveedor: </b> {item.supplierName}
          </Typography>
          <Typography variant='h6' className={classes.details}>
            <b>Origen: </b> {item.supplierOriginName}
          </Typography>
          <Typography variant='h6' className={classes.details}>
            <b>Estado: </b> {item.asnStateName}
          </Typography>
          <Typography variant='h6' className={classes.details}>
            <b>SKU totales: </b> {item.skuQty}
          </Typography>
          <Typography variant='h6' className={classes.details}>
            <b>SKU Priorizados: </b> {item.skuPriorityQty}
          </Typography>
          <Typography variant='h6' className={classes.details}>
            <b>Unidades totales: </b> {item.controlledUnitsQty}
          </Typography>
          <Typography variant='h6' className={classes.details}>
            <b>Unidades priorizados: </b>
            {item.unitsPriorityQty}
          </Typography>
        </Box>

        <Button
          type='submit'
          fullWidth
          variant='contained'
          color='primary'
          style={{
            marginTop: '20px',
            width: '95%',
            minWidth: '95%'
          }}
          onClick={() => {
            putBloqUserLpn()
            getWorkOrderSkuHistory()
            dispatch(setStep(4))
          }}
        >
          Empezar a ubicar
        </Button>
      </div>
    )
  }
  return <Fragment />
}
